const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};
const CompareTable = () => {
  return (
    <>
      <section className="PricingTable">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="text-center">
                <div className="d-inline-flex align-items-center">
                  <div className="bg-label-circle" />
                  <div className="bg-label-heading">
                    <label>Competition Analyses</label>
                  </div>
                </div>
                <div className="content">
                  <div className="Heading">
                    <h4>TRIBE vs. The Competition</h4>
                  </div>
                  <div className="Desc">
                    <p>
                      Why TRIBE stands out? <br /> The Future is Smarter with
                      TRIBE!
                    </p>
                  </div>
                  <div className="Btns">
                    <div>
                      <button className="btn start">Learn more</button>
                    </div>
                    <div>
                      <button
                        onClick={() => scrollToSection("calculator")}
                        className="btn explore"
                      >
                        Buy $ZEUSS
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="container"
          style={{ maxWidth: 1280, padding: "0px 12px" }}
        >
          <div className="row">
            <div className="col-12">
              <div className="table-responsive">
                <table className="w-100 table-demand">
                  <thead>
                    <tr>
                      <td />
                      <td>
                        <img src="./images/tribe.png" alt="" />
                      </td>
                      <td>
                        <img src="./images/whatsapp.png" alt="" />
                      </td>
                      <td>
                        <img src="./images/tiktok.png" alt="" />
                      </td>
                      <td>
                        <img src="./images/instagram.png" alt="" />
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <h4>
                          AI/ML Integration
                          <img src="./images/help-circle.svg" />
                        </h4>
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>
                          Fraud Detection
                          <img src="./images/help-circle.svg" />
                        </h4>
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>
                          Shopping
                          <img src="./images/help-circle.svg" />
                        </h4>
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>
                          Payment System
                          <img src="./images/help-circle.svg" />
                        </h4>
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>
                          Short Video Platform
                          <img src="./images/help-circle.svg" />
                        </h4>
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>
                          Predictive Insights
                          <img src="./images/help-circle.svg" />
                        </h4>
                      </td>
                      <td>
                        <img src="./images/check-circle.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                      <td>
                        <img src="./images/minus.svg" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default CompareTable;
